window.customVariantsActive = true;

document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-variant-input]')) return;

  const container = e.target.closest('[data-section-id]');
  if (!container) return;

  const selects = container.querySelectorAll('[data-variant-input]');
  const optionValueIds = [];
  const selectedValues = [];
  const selectedOptions = {};
  let productUrl = null;

  selects.forEach(input => {
    let el = input;
    if (input.tagName === 'SELECT') {
      el = input.options[input.selectedIndex] || input;
    } else if (input.type === 'radio' && !input.checked) {
      return;
    }
    const val = input.value;
    selectedValues.push(val);
    if (el.dataset.optionValueId) optionValueIds.push(el.dataset.optionValueId);

    const optKey = input.dataset.index || input.closest('[data-index]')?.dataset?.index;
    if (optKey && /^option[1-3]$/i.test(optKey)) {
      selectedOptions[optKey.toLowerCase()] = val;
    }
    const optionProductUrl = el.dataset.productUrl;
    if (optionProductUrl) {
      const currentHandle = window.location.pathname.split('/').filter(Boolean).pop();
      const optionHandle = optionProductUrl.split('?')[0].split('/').filter(Boolean).pop();
      if (currentHandle && optionHandle && currentHandle !== optionHandle) {
        productUrl = optionProductUrl;
      }
    }
  });

  const optionValuesParam = optionValueIds.join(',');

  // Combined listing redirect
  if (productUrl) {
    window.location.href = `${productUrl}?option_values=${optionValuesParam}`;
    return;
  }

  // Match variant from JSON
  const jsonEl = container.querySelector('[data-variant-json]');
  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent || jsonEl.value) || [];
  } catch (err) { }

  const hasIndexedOptions = Object.keys(selectedOptions).length > 0;

  const matchedVariant = Array.isArray(variants) ? variants.find(v => {
    const optionCount = Array.isArray(v.options) ? v.options.length : (v.option3 ? 3 : v.option2 ? 2 : 1);

    if (hasIndexedOptions) {
      for (let i = 1; i <= optionCount; i++) {
        const key = `option${i}`;
        const val = selectedOptions[key];
        if (val === undefined || v[key] !== val) return false;
      }
      return true;
    }

    for (let i = 0; i < optionCount; i++) {
      if (v[`option${i + 1}`] !== selectedValues[i]) return false;
    }
    return true;
  }) : null;

  // Immediately update point number on variant select (instant, no blinking)
  if (matchedVariant && matchedVariant.price != null) {
    var immediatePoints = Math.floor(matchedVariant.price / 100);
    container.querySelectorAll('[data-lion-points-for-product-id]').forEach(function (el) {
      el.textContent = immediatePoints;
    });
  }

  const sectionId = container.dataset.sectionId;
  const param = matchedVariant ? `variant=${matchedVariant.id}` : `option_values=${optionValuesParam}`;
  const url = `${window.location.pathname}?section_id=${sectionId}&${param}`;

  // Loading state
  const atcButtons = container.querySelectorAll('[name="add"], .add-to-cart, #au-sticky-atc-btn, .shopify-payment-button__button, .shopify-payment-button button');
  atcButtons.forEach(btn => {
    btn.disabled = true;
    btn.classList.add('btn--loading');
  });

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.querySelector(`[data-section-id="${sectionId}"]`);
      const currentSection = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (newSection && currentSection) {
        const currentHeight = currentSection.offsetHeight;
        currentSection.style.minHeight = currentHeight + 'px';

        // Use fetched HTML as source of truth for stock status
        var newAtcBtn = newSection.querySelector('[data-add-to-cart]');
        var isOOS = newAtcBtn ? newAtcBtn.hasAttribute('disabled') : (!matchedVariant || !matchedVariant.available);

        // Save live app blocks + review bar + pay & point block (they have active JS timers/widgets/state)
        var appBlockSel = '.shopify-app-block[id]';
        var reviewBarSel = '.el-review-bar';
        var odBlockSel = '[id*="order_deadline_2_app_block_product"]';
        var payAndPointSel = '.pay-and-point-block';

        // Check if current Order Deadline block already has rendered spans
        var currentOd = currentSection.querySelector(odBlockSel);
        var currentOdUnit = currentOd && currentOd.querySelector('[data-order-deadline-app-unit]');
        var odHadSpans = !!(currentOdUnit && currentOdUnit.querySelector('span'));

        var liveAppBlocks = {};
        currentSection.querySelectorAll(appBlockSel).forEach(function (el) {
          // If this is the OD block and it has no rendered spans (e.g. page loaded on OOS),
          // DO NOT preserve it. Let the fresh HTML mount so Order Deadline can initialize it.
          if (el.matches(odBlockSel) && !odHadSpans) {
            return;
          }
          liveAppBlocks[el.id] = el;
        });
        var liveReviewBar = currentSection.querySelector(reviewBarSel);
        var livePayAndPoint = currentSection.querySelector(payAndPointSel);

        // Swap HTML
        currentSection.innerHTML = newSection.innerHTML;

        // Preserve live pay-and-point block (updates the point only, prevents full-line blinking)
        var freshPayAndPoint = currentSection.querySelector(payAndPointSel);
        if (livePayAndPoint && freshPayAndPoint) {
          var freshLis = freshPayAndPoint.querySelectorAll('ul > li');
          var liveLis = livePayAndPoint.querySelectorAll('ul > li');
          if (freshLis[0] && liveLis[0]) {
            var f0 = freshLis[0].querySelector('span');
            var l0 = liveLis[0].querySelector('span');
            if (f0 && l0) l0.innerHTML = f0.innerHTML;
          }
          if (freshLis[1] && liveLis[1]) {
            var f1 = freshLis[1].querySelector('span');
            var l1 = liveLis[1].querySelector('span');
            if (f1 && l1) l1.innerHTML = f1.innerHTML;
          }
          freshPayAndPoint.replaceWith(livePayAndPoint);
        }

        // Update ONLY the point number on any [data-lion-points-for-product-id]
        if (matchedVariant && matchedVariant.price != null) {
          var lionPoints = Math.floor(matchedVariant.price / 100);
          currentSection.querySelectorAll('[data-lion-points-for-product-id]').forEach(function (el) {
            el.textContent = lionPoints;
          });
        }

        // Re-insert live app blocks over their fresh uninitialised copies
        Object.keys(liveAppBlocks).forEach(function (id) {
          var fresh = currentSection.querySelector('#' + CSS.escape(id));
          if (fresh) fresh.replaceWith(liveAppBlocks[id]);
        });

        // Re-insert live review bar into the new ATC container
        if (liveReviewBar) {
          currentSection.querySelectorAll(reviewBarSel).forEach(function (el) { el.remove(); });
          var atcBlock = currentSection.querySelector('#product-block__quantity_selector_and_atc');
          if (atcBlock) atcBlock.appendChild(liveReviewBar);
        }

        requestAnimationFrame(() => { currentSection.style.minHeight = ''; });

        // Rebind ajax cart form
        currentSection.querySelectorAll('.product-single__form').forEach(form => {
          form.removeAttribute('onsubmit');
          form.onsubmit = null;
          if (window.theme?.settings?.cartType === 'drawer' && window.theme.AjaxProduct) {
            new window.theme.AjaxProduct(form);
          }
        });

        // Re-init quantity buttons
        if (window.theme?.QtySelector) {
          currentSection.querySelectorAll('.js-qty__wrapper').forEach(el => {
            new window.theme.QtySelector(el, { namespace: '.product', isCart: true });
          });
        }

        // Re-init product slideshow (Flickity + thumb click handlers)
        if (window.theme?.sections) {
          const productContainer = currentSection.querySelector('[data-section-type="product"]') || currentSection;
          if (productContainer && window.theme.Product) {
            // Remove stale instance
            const oldInstance = theme.sections._findInstance(sectionId);
            if (oldInstance) {
              if (typeof oldInstance.onUnload === 'function') {
                try { oldInstance.onUnload(); } catch (_) {}
              }
              theme.sections._removeInstance(sectionId);
            }
            // Create fresh instance which inits slider + thumb listeners
            theme.sections._createInstance(productContainer, window.theme.Product, currentSection);
          }
        }

        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: matchedVariant } }));

        // Order Deadline: handle OOS / in-stock / low-stock transitions
        (function() {
          var block = currentSection.querySelector('div[id*="order_deadline_2_app_block_product"]');
          if (!block) return;
          var appUnit = block.querySelector('[data-order-deadline-app-unit]');
          var existingPulse = block.querySelector('#order-deadline-in-stock-pulse-container');
          var oosOverlay = block.querySelector('#order-deadline-oos-overlay');

          if (isOOS) {
            // ── ANY → OOS ──
            if (appUnit) appUnit.style.display = 'none';
            if (existingPulse) existingPulse.remove();
            if (!oosOverlay) {
              block.insertAdjacentHTML('afterbegin',
                '<div id="order-deadline-oos-overlay" style="display:flex;align-items:baseline;gap:10px;">' +
                '<div style="position:relative;width:12px;height:12px;">' +
                '<div id="order-deadline-oos-pulse" class="order-deadline-pulse"></div></div>' +
                '<span style="color:#ffffff;font-weight:600;">Awaiting Stock</span></div>');
            }
          } else {
            // ── OOS/IN-STOCK → IN-STOCK / LOW-STOCK ──
            if (oosOverlay) oosOverlay.remove();
            if (existingPulse) existingPulse.remove();

            if (appUnit) {
              appUnit.style.cssText = '';
              appUnit.querySelectorAll('*').forEach(function(child) {
                if (child.style.display === 'none' || child.style.visibility === 'hidden') {
                  child.style.cssText = '';
                }
              });
            }

            var lowStockEl = currentSection.querySelector('[data-product-inventory]');
            var isLowStock = lowStockEl && lowStockEl.textContent.toLowerCase().includes('low stock');
            var stockSpan = appUnit && appUnit.querySelector('span');

            if (stockSpan) {
              // App unit ALREADY has rendered content (spans/timer)
              if (isLowStock) {
                block.insertAdjacentHTML('afterbegin',
                  '<div id="order-deadline-in-stock-pulse-container"><div id="order-deadline-low-stock-pulse" class="order-deadline-pulse"></div></div>');
                stockSpan.textContent = lowStockEl.textContent;
                stockSpan.classList.add('low-stock-text');
              } else {
                block.insertAdjacentHTML('afterbegin',
                  '<div id="order-deadline-in-stock-pulse-container"><div id="order-deadline-in-stock-pulse" class="order-deadline-pulse"></div></div>');
                if (!stockSpan.textContent.toLowerCase().includes('in stock:')) {
                  stockSpan.textContent = 'In stock: ';
                }
                stockSpan.classList.remove('low-stock-text');
              }
            } else {
              // App unit was NOT rendered yet (e.g. page loaded on OOS variant)
              // 1. Ensure form [name="id"] has the new variant id
              var formVariantInput = currentSection.querySelector('[name="id"]');
              if (formVariantInput && matchedVariant) {
                formVariantInput.value = matchedVariant.id;
                formVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
              }

              // 2. Start waiting for Order Deadline to render spans
              if (typeof window.waitForSpans === 'function') {
                window.waitForSpans(currentSection);
              }

              // 3. Trigger Order Deadline app initialization to mount widget
              if (window.orderDeadlineAppApi && typeof window.orderDeadlineAppApi.init === 'function') {
                window.orderDeadlineAppApi.init();
              } else {
                document.addEventListener('orderDeadlineApp:api:ready', function(e) {
                  if (e.detail?.api?.init) e.detail.api.init();
                }, { once: true });
              }
            }
          }
        })();
      }

      // Update URL
      try {
        const urlParams = new URLSearchParams(window.location.search);
        if (matchedVariant) {
          urlParams.set('variant', matchedVariant.id);
          urlParams.delete('option_values');
        } else if (optionValuesParam) {
          urlParams.set('option_values', optionValuesParam);
          urlParams.delete('variant');
        }
        urlParams.delete('section_id');
        const qs = urlParams.toString();
        const newUrl = `${window.location.pathname}${qs ? '?' + qs : ''}${window.location.hash}`;
        history.replaceState(null, '', newUrl);
      } catch (_) {
        history.replaceState(null, '', `?${param}`);
      }
    })
    .catch(err => console.error('Variant update failed:', (err && err.message) ? err.message : err))
    .finally(() => {
      const currentSection = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (currentSection) {
        currentSection.querySelectorAll('[name="add"], .add-to-cart, #au-sticky-atc-btn, .shopify-payment-button__button, .shopify-payment-button button').forEach(btn => {
          btn.classList.remove('btn--loading');
        });
      }
    });
});